import { getSupportedCurrencies } from '../actions';
const STORAGE_NAME_CURRENCY = 'currencyFromPricingPage';
export const getUserCurrency = async (locationDetails) => {
    const locationCurrency = locationDetails &&
        locationDetails.location &&
        locationDetails.location.currency &&
        locationDetails.location.currency.code;
    const supportedCurrencies = (await getSupportedCurrencies()) || [];
    const storedCurrency = window.sessionStorage.getItem(STORAGE_NAME_CURRENCY) ||
        window.localStorage.getItem(STORAGE_NAME_CURRENCY) ||
        locationCurrency ||
        'USD';
    const isSupportedCurrency = supportedCurrencies.includes(storedCurrency.toLowerCase());
    return isSupportedCurrency ? storedCurrency : 'USD';
};
